// The rasteriser web-app-next uses, from frontend/packages/ui (no React in
// it), compiled as this app's: see patches/react-scripts+5.0.1.patch.
import {
  svgToPng,
  EmbeddedFont,
} from "../../../../../../../../packages/ui/src/lib/svgToPng";
import { SHARE_CARD_HEIGHT, SHARE_CARD_WIDTH } from "./ShareCard";
import workSans from "../../../../../../../../packages/ui/src/tokens/fonts/WorkSans-latin.woff2";

/**
 * The card's face, drawn into the bitmap so it carries the brand type.
 * Only the PNG is handed out: an SVG would carry the font files themselves.
 */
const FONTS: EmbeddedFont[] = [
  { family: "Work Sans", url: workSans, weight: "400 700" },
];

const FILE_NAME = "wone-index.png";

/** How long a download's object URL outlives the click: Safari starts the
 * download after `click()` returns, and a revoked URL saves nothing. */
const REVOKE_AFTER_MS = 30000;

/**
 * Whether this browser's share sheet takes an image file. Asked of a stand-in
 * PNG, so the preview knows which button to offer before the image is made.
 */
export function canShareImageFiles(): boolean {
  const probe = new File([], FILE_NAME, { type: "image/png" });
  return (
    typeof navigator.canShare === "function" &&
    navigator.canShare({ files: [probe] })
  );
}

/**
 * The card on the page as a PNG, made before the learner presses anything,
 * so a press can hand it to the share sheet while it still counts as one.
 */
export async function makeSharePng(card: SVGSVGElement): Promise<File> {
  const bitmap = await svgToPng(card, {
    width: SHARE_CARD_WIDTH,
    height: SHARE_CARD_HEIGHT,
    fonts: FONTS,
  });
  return new File([bitmap], FILE_NAME, { type: "image/png" });
}

/** Saves the file through the browser's own download. */
export function downloadFile(file: File): void {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.name;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
